import { render } from "./ImpressumShop.vue?vue&type=template&id=ea8359b4&scoped=true"
import script from "./ImpressumShop.vue?vue&type=script&lang=js"
export * from "./ImpressumShop.vue?vue&type=script&lang=js"

import "./ImpressumShop.vue?vue&type=style&index=0&id=ea8359b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea8359b4"]])

export default __exports__